import React from "react";
import { Star } from "lucide-react";

export default function Stars({ value = 0, size = 14, className = "" }) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(value) ? "text-accent fill-accent" : "text-border"}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}
